import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close(event) {
    const alertRoot = document.querySelector('[role="alert"]')
    alertRoot.style = 'display:none'
  }
}
